module.exports = __webpack_public_path__ + "img/logo2.456300f2.png";